module.exports = __webpack_public_path__ + "static/media/info12_Militante_representante_JDE.c4ad051b.png";